import React from "react";
import { Button, Icon } from "antd";
import { useTranslation } from "react-i18next";

const ScreenDetailHeader = ({ campaignId, campaignName, screenName, history, onBuy }) => {
  const { t } = useTranslation();

  return (
    <div className="screenDetail__topbar">
      <nav className="screenDetail__breadcrumb">
        <span
          className="screenDetail__crumb-link"
          onClick={() => history && history.push("/campaigns")}
        >
          {t("My campaigns")}
        </span>
        {campaignName && (
          <>
            <span className="screenDetail__crumb-sep"> / </span>
            {campaignId ? (
              <span
                className="screenDetail__crumb-link"
                onClick={() => history && history.push(`/campaign/${campaignId}`)}
              >
                {campaignName}
              </span>
            ) : (
              <span>{campaignName}</span>
            )}
          </>
        )}
        <span className="screenDetail__crumb-sep"> / </span>
        <span className="screenDetail__crumb-current">{screenName}</span>
      </nav>

      <Button type="primary" className="screenDetail__buy" onClick={onBuy}>
        {t("Go to buy")} <Icon type="shopping-cart" />
      </Button>
    </div>
  );
};

export default ScreenDetailHeader;
